import {isEmpty, unFormatAmount} from "@/util/Helpers"
import {dateToEpoch, formatDateUTCDefault} from "@/util/DateUtil";
import {helpers} from "vuelidate/lib/validators";
import moment from "moment/moment";
import store from "@/store";

export const emailValidator = helpers.regex('emailValidator',
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
export const datePatternValidator = helpers.regex('datePatternValidator',
    /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/)

export const namesValidator = (value) => {
    let match = (isEmpty(value) ? "" : value.toString().match(/(?:^(?:[Α-Ω/\s\-]+)|(?:[A-Z/\s\-]+)$)|(?:^(?:[A-Z/\s\-]+)|(?:[Α-Ω/\s\-]+)$)/g));
    return (isEmpty(value)) || (!isEmpty(match) && match[0] === value.toString());
}


export const idiothta1Validation = (value) => {
    let findParent = store.getters["lookups/getIdiothta"].find(x => {
        if (x.value !== null) {
            if (!isEmpty(x.value) && !isEmpty(value) && !isEmpty(value.idiothta)) {
                {
                    if (x.value.t048Id !== undefined && x.value.parentId === value.idiothta.t048Id)
                        return x
                }
            }
        }
    })
    return (isEmpty(value.idiothta1) && !isEmpty(findParent))
}
export const idiothta2Validation = (value) => {
    let findParent = store.getters["lookups/getIdiothta"].filter(x => {
        if (x.value !== null) {
            if (!isEmpty(x.value) && !isEmpty(value) && !isEmpty(value.idiothta1)) {
                {
                    if (Object.prototype.hasOwnProperty.call(x.value, 'parentId'))
                        if (!isEmpty(x.value.t048Id)) {
                            if (x.value.parentId === value.idiothta1.t048Id) {
                                return x
                            }
                        }
                }
            }
        }
    })
    return (isEmpty(value.idiothta2) && !isEmpty(findParent))
}
export const idiothta3Validation = (value) => {
    let findParent = store.getters["lookups/getIdiothta"].filter(x => {
        if (x.value !== null) {
            if (!isEmpty(x.value) && !isEmpty(value) && !isEmpty(value.idiothta2)) {
                {
                    if (Object.prototype.hasOwnProperty.call(x.value, 'parentId'))
                        if (!isEmpty(x.value.t048Id)) {
                            if (x.value.parentId === value.idiothta2.t048Id) {
                                return x
                            }
                        }
                }
            }
        }
    })
    return (isEmpty(value.idiothta3) && !isEmpty(findParent))
}

export const yearValidation = (value) => {
    let epochDate = moment(value, 'DD/MM/YYYY').valueOf()
    return isEmpty(value) || !isEmpty(value) && (new Date(epochDate).getFullYear() <= new Date().getFullYear() && new Date(epochDate).getFullYear() > 1900);
}
export const intYearValidation = (value) => {
    //let epochDate = moment(value, 'DD/MM/YYYY').valueOf()
    return isEmpty(value) || !isEmpty(value) && (parseInt(value) <= new Date().getFullYear() && parseInt(value) > 1900);
}

export const intYearOnlyPastValidation = (value) => {
    //let epochDate = moment(value, 'DD/MM/YYYY').valueOf()
    return isEmpty(value) || parseInt(value) > 1900;
}
export const yearOnlyPastValidation = (value) => {
    let epochDate = moment(value, 'DD/MM/YYYY').valueOf()
    return isEmpty(value) || !isEmpty(value) && new Date(epochDate).getFullYear() > 1900;
}

export const adtAgmValidation = (value) => {
    return isEmpty(value) || value.trim().replace(/ /g, "") === "--" || !isEmpty(value.toString().match(/^([Α-ΩA-Z0-9]|(\s?-\s?))+$/g));
}


export const formatAmount = (amount) => {
    amount = unFormatAmount(amount);
    let numOfDecimals = 2;
    let decimalsRegex = new RegExp("\\.(\\d{" + numOfDecimals + "})$");
    return parseFloat(amount).toFixed(numOfDecimals).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        .replace(/,/g, ".")
        .replace(decimalsRegex, ",$1");
}


export const amountValidator = (value) => {
    if (isEmpty(value)) {
        return true
    } else {
        value = unFormatAmount(value);
        return !isEmpty(value)
    }
}
export const afmValidator = (value) => {
    if (!isEmpty(value) && !isEmpty(value)) {
        let afm = value.toString()
        if (afm === '000000000')
            return true;
        if (!afm.match(/^\d{9}$/) || afm === '000000000')
            return false;
        let m = 1, sum = 0;
        for (let i = 7; i >= 0; i--) {
            m *= 2;
            sum += afm.charAt(i) * m;
        }
        return sum % 11 % 10 == afm.charAt(8);
    } else {
        return true
    }
}
export const endsAtAfterStartsAt = (value, model) => {
    if (isEmpty(value) || isEmpty(model.startsAtCalc)) {
        return true
    }
    const fmts = ['YYYY-MM-DD', 'DD/MM/YYYY', 'YYYY-MM-DD HH:mm:ss']
    const end = moment(value, fmts, true)
    const start = moment(model.startsAtCalc, fmts, true)
    if (!end.isValid() || !start.isValid()) {
        return true
    }
    return end.isSameOrAfter(start, 'day')
}
export const hmYpovolhsKatalogEos = (value, model) => {
    let epochDateValue = moment(value, 'DD/MM/YYYY').valueOf()
    let epochDateModel = moment(model.hmApoKatCalc, 'DD/MM/YYYY').valueOf()
    return isEmpty(value) || epochDateValue >= epochDateModel
}
export const hmYpovolhsKatalogApo = (value, model) => {
    let epochDateValue = moment(value, 'DD/MM/YYYY').valueOf()
    let epochDateModel = moment(model.hmEosKatCalc, 'DD/MM/YYYY').valueOf()
    return isEmpty(value) || epochDateValue < epochDateModel
}
export const hmYpovolhsDpkEos = (value, model) => {
    let epochDateValue = moment(value, 'DD/MM/YYYY').valueOf()
    let epochDateModel = moment(model.hmApoCalc, 'DD/MM/YYYY').valueOf()
    return isEmpty(value) || epochDateValue >= epochDateModel
}
export const hmYpovolhsDpkApo = (value, model) => {
    let epochDateValue = moment(value, 'DD/MM/YYYY').valueOf()
    let epochDateModel = moment(model.hmEosCalc, 'DD/MM/YYYY').valueOf()
    return isEmpty(value) || epochDateValue < epochDateModel
}

export const initialDPKEos = (value, model) => {
    if (isEmpty(value)) return true
    if (isEmpty(model.allowInitialDPKFromCalc)) return true
    let epochDateValue = moment(value, 'DD/MM/YYYY').valueOf()
    let epochDateModel = moment(model.allowInitialDPKFromCalc, 'DD/MM/YYYY').valueOf()
    return epochDateValue >= epochDateModel
}
export const initialDPKApo = (value, model) => {
    if (isEmpty(value)) return true
    if (isEmpty(model.allowInitialDPKUntilCalc)) return true
    let epochDateValue = moment(value, 'DD/MM/YYYY').valueOf()
    let epochDateModel = moment(model.allowInitialDPKUntilCalc, 'DD/MM/YYYY').valueOf()
    return epochDateValue < epochDateModel
}

export const hmDhloshsSyzygoyEos = (value, model) => {
    let epochDateValue = moment(value, 'DD/MM/YYYY').valueOf()
    let epochDateModel = moment(model.hmDhloshsSyzygoyApoCalc, 'DD/MM/YYYY').valueOf()
    return isEmpty(value) || epochDateValue >= epochDateModel
}

export const hmDhloshsSyzygoyApo = (value, model) => {
    let epochDateValue = moment(value, 'DD/MM/YYYY').valueOf()
    let epochDateModel = moment(model.hmDhloshsSyzygoyEosCalc, 'DD/MM/YYYY').valueOf()
    return isEmpty(value) || epochDateValue < epochDateModel
}


export const amkaValidator = (value) => {
    if (!isEmpty(value) && !isEmpty(value)) {
        let amka = value.toString();
        if (!isEmpty(amka)) {
            if (amka === "12345678901" || amka === "11111111111" || amka === "22222222222")
                return true;
            if (!amka.match(/^\d{11}$/) || amka === "11111111111" || amka === "22222222222" || amka === "00000000000")
                return false;

            let iSum = 0;
            for (let i = 1; i <= amka.length; i++) {
                let iDigit = parseInt(amka.charAt(i - 1), 10);
                if (i % 2 === 0) {
                    iDigit *= 2;
                    if (iDigit > 9) {
                        iDigit -= 9;
                    }
                }
                iSum += iDigit;
            }
            return (iSum % 10 === 0);
        }
    } else {
        return true
    }
}

const STRICT_DATE_FORMATS = ['DD/MM/YYYY', 'YYYY-MM-DD', 'YYYY-MM-DD HH:mm:ss']

export const dateValidator = (value) => {
    if (!isEmpty(value) && value !== '') {
        return moment(value, STRICT_DATE_FORMATS, true).isValid();
    }
    return true
}

export const noFutureDateValidator = (value) => {
    return isEmpty(value) || dateToEpoch(value) <= Date.now()
}
export const hmAnalhpshsValidator = (value) => {
    const fromDate = new Date(store.getters['catalog/getCatalog'].etos, store.getters['catalog/getCatalog'].month - 2, 0);
    const fromDate1 = new Date(moment(fromDate).set("hours", 23).set("minute", 59).set("seconds", 59).format('YYYY-MM-DD HH:mm:ss'))

    const toDate = new Date(store.getters['catalog/getCatalog'].etos, store.getters['catalog/getCatalog'].month - 1, 1);
    const toDate1 = new Date(moment(toDate).set("hours", 0).set("minute", 0).set("seconds", 0).format('YYYY-MM-DD HH:mm:ss'))


    return isEmpty(value) || (formatDateUTCDefault(value).getTime() >= fromDate1.getTime() && formatDateUTCDefault(value).getTime() <= toDate1.getTime())
}

const SPECIAL_T054_IDS = new Set([2853, 2854, 2855, 2856]);

export const isSpecialT054 = (model) => {
  const raw = JSON.parse(JSON.stringify(model)).idiothta.t048Id;
  const id = Number(raw);
  return SPECIAL_T054_IDS.has(id);
};

export const childAgeCheck = (value, model) => {

  if (isEmpty(value)) return true;
  if (!isSpecialT054(model)) return true;

  const child = store.getters["catalog/getChild"];
  if (isEmpty(child)) return true;

  const dobStr = child?.birthDate;
  if (isEmpty(dobStr)) return true;

  const ref = moment(value, "DD/MM/YYYY", true).startOf("day");
  if (!ref.isValid()) return true;

  const dob = moment(dobStr, "DD/MM/YYYY", true).startOf("day");
  if (!dob.isValid()) return true;

  const eighteenth = dob.clone().add(18, "years").startOf("day");

  return ref.isBefore(eighteenth, "day");
};

export const hmApoleiasValidator = (value, model) => {
    let lastDate = new Date(store.getters['catalog/getCatalog'].etos, store.getters['catalog/getCatalog'].month, 0);
    let lastDate1 = new Date(moment(lastDate).set("hours", 23).set("minute", 59).format('YYYY-MM-DD HH:mm:ss'))
    return isEmpty(value) || (formatDateUTCDefault(value).getTime() <= lastDate1.getTime() && formatDateUTCDefault(value).getTime() >= formatDateUTCDefault(model?.hmAnalhpshsCalc).getTime())
}

export const hmApoleiasEtosValidator = (value, model) => {
    if (isEmpty(value)) return true;
    const catalog = store.getters['catalog/getCatalog'];
    const apoleiasYear = formatDateUTCDefault(value).getFullYear();
    const isVouliRouting = model?.idiothtaT048?.isVouliRouting === true;
    const minYear = catalog.etos - (isVouliRouting ? 3 : 1);
    return apoleiasYear >= minYear;
}

export const aitiaApoleiasValidator = (model) => {
    return !isEmpty(model?.hmApoleiasCalc)
}

export const afmSyzygouValidator = (value, model) => {
    if (isEmpty(value)) return true
    const syzygosAfm = parseInt(value, 10)
    const mainAfm = parseInt(model.afm, 10)
    if (isNaN(syzygosAfm) || isNaN(mainAfm)) return true
    return syzygosAfm !== mainAfm
}

export const hasOrganikhMonada = (model) => {
    return checkIdiotitesByField(model, 'organikhMonadaDecr:1')
}
export const hasNeaOrganikhMonada = (model) => {
    return checkIdiotitesSyzygos(model)
}
export const hasBathmos = (model) => {
    return checkIdiotitesByField(model, 'bathmosT044:1')
}
export const hasHmDiorismoy = (model) => {
    return checkIdiotitesByField(model, 'hmDiorismoy:1')
}
export const hasKladosEidikothta = (model) => {
    return checkIdiotitesByField(model, 'kladosEidikothta:1')
}
export const hasArmodiothtaT038 = (model) => {
    return checkIdiotitesByField(model, 'armodiothtaT038:1')
}
export const kathgoriaYpoxreouT045 = (model) => {
    return checkIdiotitesByField(model, 'kathgoriaYpoxreouT045:1')
}
const checkIdiotitesByField = (model, field) => {
    let index = 0
    if (!isEmpty(model?.katalogosIdiothtaT054Collection)) {
        if (Object.prototype.hasOwnProperty.call(model?.katalogosIdiothtaT054Collection, '$model')) {
            if (!isEmpty(model?.katalogosIdiothtaT054Collection.$model)) {
                if (model?.katalogosIdiothtaT054Collection.$model?.length > 0) {
                    model?.katalogosIdiothtaT054Collection.$model?.find(x => {
                        if (!isEmpty(x)) {
                            if (!isEmpty(x.idiothtaT048)) {
                                if (Object.prototype.hasOwnProperty.call(x.idiothtaT048, 'fields')) {
                                    if (x.idiothtaT048.fields.includes(field)) {
                                        index = 1
                                    }
                                }
                            }
                        }

                    })
                }
            }
        } else {
            if (!isEmpty(model?.katalogosIdiothtaT054Collection)) {
                if (model?.katalogosIdiothtaT054Collection.length > 0) {
                    model?.katalogosIdiothtaT054Collection.find(x => {
                        if (!isEmpty(x.idiothtaT048)) {
                            if (Object.prototype.hasOwnProperty.call(x.idiothtaT048, 'fields')) {
                                if (x.idiothtaT048.fields.includes(field)) {
                                    index = 1
                                }
                            }
                        }
                    })
                }
            }
        }
    }
    return index > 0
}
const checkIdiotitesSyzygos = (model) => {
    let index = 0
    if (!isEmpty(model?.katalogosIdiothtaT054Collection)) {
        if (Object.prototype.hasOwnProperty.call(model?.katalogosIdiothtaT054Collection, '$model')) {
            if (!isEmpty(model?.katalogosIdiothtaT054Collection.$model)) {
                if (model?.katalogosIdiothtaT054Collection.$model?.length > 0) {
                    model?.katalogosIdiothtaT054Collection.$model?.find(x => {
                        if (!isEmpty(x)) {
                            if (!isEmpty(x.idiothtaT048)) {
                                index = [2302, 2251, 2253, 2252, 2854, 2855, 2856, 2853].includes(x.idiothtaT048.t048Id) ? 1 : 0
                            }
                        }

                    })
                }
            }
        } else {
            if (!isEmpty(model?.katalogosIdiothtaT054Collection)) {
                if (model?.katalogosIdiothtaT054Collection.length > 0) {
                    model?.katalogosIdiothtaT054Collection.find(x => {
                        if (!isEmpty(x.idiothtaT048)) {
                            index = [2302, 2251, 2253, 2252, 2854, 2855, 2856, 2853].includes(x.idiothtaT048.t048Id) ? 1 : 0
                        }
                    })
                }
            }
        }
    }
    return index > 0
}